var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-progress-wrapper"},[_c('div',{staticClass:"progress-bar",class:{ finished: _vm.widthAsPercentage === 100 },style:(`width: ${_vm.widthAsPercentage}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }